export default "__VITE_ASSET__C1c5Nk47__"